import { ActionFunctionArgs, redirect } from 'react-router';
import { authClient } from '../../../lib/auth-client';

export async function registerAction({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const firstName = formData.get('firstName') as string;
  const lastName = formData.get('lastName') as string;
  const email = formData.get('email') as string;
  const password = formData.get('password') as string;
  const confirmPassword = formData.get('confirmPassword') as string;

  // Validation
  if (password !== confirmPassword) {
    return {
      error: 'Passwords do not match',
      values: { firstName, lastName, email },
    };
  }

  if (password.length < 8) {
    return {
      error: 'Password must be at least 8 characters',
      values: { firstName, lastName, email },
    };
  }

  try {
    const { data, error } = await authClient.signUp.email({
      email,
      password,
      name: `${firstName} ${lastName}`.trim(),
    });

    if (error) {
      return {
        error: error.message || 'Registration failed',
        values: { firstName, lastName, email },
      };
    }

    if (data?.user) {
      // New users always need onboarding after registration
      throw redirect('/onboarding');
    }

    return {
      error: 'Registration failed - unexpected response format',
      values: { firstName, lastName, email },
    };
  } catch (error: any) {
    // Re-throw redirect responses (React Router navigation)
    if (error instanceof Response) {
      throw error;
    }
    
    return {
      error: error.message || 'Failed to create account',
      values: { firstName, lastName, email },
    };
  }
}